export const applicationRouteNames = {
  home: 'home',
  administration: 'administration',
  users: 'users',
  subsidiaries: 'subsidiaries',
  contacts: 'contacts',
  reports: 'reports',
  lokalise: 'lokalise',
};
